/*
   * Evaluation attachment, specific to evaluation phase & prescoring
   */

import React from 'react';

import {
  castDataType,
  DataType,
}
from '../common.jsx'
import Setting from './setting.jsx';

import Attachment from './attachment.jsx'

export default class EvaluationAttachment extends Attachment {

    constructor(props){
      super(props);
      //this.downloadUrl = this.props.attachmentDownloadUrl ? this.props.attachmentDownloadUrl.replace('__name__', this.fullFieldName()) + (this.props.content.isPrescoring ? '/prescoring' : '') : ''
    }

    static get CATEGORY() {
      return 'question';
    }

    static get TYPE() {
        return 'evaluation_attachment';
    }


    static defaultContent(language) {
      return Object.assign(super.defaultContent(language), {
        isPrescoring: false
      });
    }

    containerClassNames() {
      let classNames = super.containerClassNames();

      if (this.props.content.isPrescoring) {
          classNames.push('prescoring');
      }

      // Add attachment for styles
      classNames.push('attachment')
      return classNames;
    }


    renderSettings() {
      let isPrescoring = this.props.content.isPrescoring;
      // Since "isPrescoring" is a later addition the default is here set to
      // false for forms created before the change.
      if (typeof isPrescoring == 'undefined') {
          isPrescoring = false;
      }

      return (<div>
        <Setting.Checkbox
            name="isPrescoring"
            label={I18n.t('field_is_prescoring', {scope: 'fe'})}
            value={isPrescoring}
            description={I18n.t('field_is_prescoring_description', {scope: 'fe'})}
            onChange={this.updateSettings} />
        {super.renderSettings()}
      </div>)

    }

    beforeUpdateSettings(content, deletedRowIndex, deletedColIndex) {
      content.isPrescoring = castDataType(content.isPrescoring, DataType.BOOLEAN);
      super.beforeUpdateSettings(content, deletedRowIndex,deletedColIndex);
    }
}
